import {ToggleView} from './ToggleView';

export class SvgToggleView extends ToggleView {

    public constructor(checkedHref: string, uncheckedHref: string) {
        super(
            `<svg width="100%" height="100%"><use href="${checkedHref}" xlink:href="${checkedHref}"/></svg>`,
            `<svg width="100%" height="100%"><use href="${uncheckedHref}" xlink:href="${uncheckedHref}"/></svg>`);
    }
}
